import React from "react";
import { Link } from "react-router-dom";

export default function BannerSection({
  heading = "Home",
  image = "images/counter_bg.jpg",
  title = "home",
  description = "cart view",
  path = "/cartview",
}) {
  return (
    <div>
      <section
        className="page_breadcrumb"
        style={{
          background: `url(${image})`,
          backgoundPosition: "bottom",
        }}
      >
        <div class="breadcrumb_overlay">
          <div class="container">
            <div class="breadcrumb_text">
              <h1>{heading}</h1>
              <ul>
                <li>
                  <Link className="font-20" to={path}>{title}</Link>
                </li>
                <li>
                  <Link className="font-20" to={path}>{description}</Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
